import { Component, input } from "@angular/core";
import { FormGroup, ReactiveFormsModule } from "@angular/forms";
import { MatSlideToggle } from "@angular/material/slide-toggle";
import { MatCheckbox } from "@angular/material/checkbox";
import { NgClass } from "@angular/common";
import { LayerInfoForm } from "../models/layer-info-form.interface";
import { LayerInfoViewModel } from "../models/layer-info-view-model.interface";
import { ExpandableTextComponent } from "@components/expandable-text/expandable-text.component";

@Component({
  selector: "app-layer-info",
  standalone: true,
  templateUrl: "./layer-info.component.html",
  styleUrls: ["./layer-info.component.scss"],
  imports: [ReactiveFormsModule, MatSlideToggle, MatCheckbox, NgClass, ExpandableTextComponent]
})
export class LayerInfoComponent {
  form = input.required<FormGroup<LayerInfoForm>>();
  viewModel = input.required<LayerInfoViewModel>();
  useSlideToggle = input(false);
  isLast = input(false);

  toggleLayerActivation(): void {
    const current = this.form().controls.isActivated.value;
    this.form().controls.isActivated.setValue(!current);
  }

  onKeydown(event: KeyboardEvent): void {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      this.toggleLayerActivation();
    }
  }
}
